import { filterSinglePostByCategory } from './categoryFilters';

export function addParamsToRelatedPost(posts) {
  return posts.map((post) => {
    switch (post.__typename) {
      case 'Post':
        return {
          ...post,
          path: `${filterSinglePostByCategory(post, 'Supply') ? '/engineers/blog/' : '/blog/'}${
            post.slug
          }`,
          target: '_self',
          resourceType: 'Blog Post',
        };
      case 'Guide':
        return {
          ...post,
          path: post.guidePostType.guideType
            ? post.guidePostType.externalLink.url
            : `${filterSinglePostByCategory(post, 'Supply') ? '/engineers/guides/' : '/guides/'}${
                post.slug
              }`,
          target: post.guidePostType.guideType ? '_blank' : '_self',
          resourceType: 'Guide',
        };
      case 'Webinar':
        return {
          ...post,
          path: `/webinars/${post.slug}`,
          target: '_self',
          resourceType: 'Webinar',
        };
      case 'Video':
        return {
          ...post,
          path: `${filterSinglePostByCategory(post, 'Supply') ? '/engineers/videos/' : '/videos/'}${
            post.slug
          }`,
          target: '_self',
          resourceType: 'Video',
        };
      case 'GlobalEngineer':
        return {
          ...post,
          path: `/engineers/the-global-engineer/archive/${post.slug}`,
          target: '_self',
          resourceType: 'GlobalEngineer',
        };
      case 'Unlock':
        return {
          ...post,
          path: `/unlock/${post.slug}`,
          target: '_self',
          resourceType: 'Unlock',
        };
      case 'PressPost':
        return {
          ...post,
          path: `/press/${post.slug}`,
          target: '_self',
          resourceType: 'Press',
        };
      case 'PressRelease':
        return {
          ...post,
          path: `/press/${post.slug}`,
          target: '_self',
          resourceType: 'PressRelease',
        };
      case 'NewsPost':
        return {
          ...post,
          path: `/press/${post.slug}`,
          target: '_self',
          resourceType: 'News Post',
        };
      case 'LearnArticle':
        return {
          ...post,
          path: `${filterSinglePostByCategory(post, 'Supply') ? '/engineers/blog/' : '/blog/'}${
            post.slug
          }`,
          target: '_self',
          resourceType: 'Blog Post',
        };
      default:
        return {
          ...post,
          path: `${filterSinglePostByCategory(post, 'Supply') ? '/engineers/blog/' : '/blog/'}${
            post.slug
          }`,
          target: '_self',
          resourceType: 'Blog Post',
        };
    }
  });
}
